import { Search, X } from "lucide-react";
import React, { useState, useEffect } from "react";
import { Button, TextInput, ActionIcon, Group } from "@mantine/core";

interface QuerySearchInputProps {
  value?: string;
  onSearch: (query: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const QuerySearchInput: React.FC<QuerySearchInputProps> = ({
  value = "",
  onSearch,
  disabled = false,
  isLoading = false,
}) => {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const handleSubmit = (): void => {
    if (searchValue.length >= 2 || searchValue.length === 0) {
      onSearch(searchValue);
    }
  };

  const handleClear = (): void => {
    setSearchValue("");
    onSearch("");
  };

  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  const showClearButton = !isLoading && searchValue.length > 0;

  return (
    <TextInput
      autoFocus
      radius="md"
      size="md"
      style={{
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderRight: "none",
        width: "600px",
        maxWidth: "100%",
      }}
      onChange={(e) => setSearchValue(e.target.value)}
      value={searchValue}
      icon={<Search size={18} />}
      rightSectionWidth={showClearButton ? 122 : 88}
      placeholder="Search by employee name or number"
      disabled={disabled || isLoading}
      onKeyDown={handleKeyDown}
      error={
        searchValue.length > 0 && searchValue.length < 2
          ? "Minimum 2 characters required"
          : null
      }
      rightSection={
        <Group spacing={0} noWrap>
          {showClearButton && (
            <ActionIcon
              size={35}
              onClick={handleClear}
              disabled={disabled || isLoading}
              variant="transparent"
              color="gray"
            >
              <X size={14} />
            </ActionIcon>
          )}
          <Button
            color="jem-theme"
            style={{
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              height: "43px",
            }}
            onClick={handleSubmit}
            disabled={
              disabled ||
              isLoading ||
              (searchValue.length > 0 && searchValue.length < 2)
            }
            loading={isLoading}
          >
            Search
          </Button>
        </Group>
      }
    />
  );
};

export default QuerySearchInput;
